function initialiseNayorah(root) {
  if (!root || root.dataset.initialised) return;
  root.dataset.initialised = 'true';
  const filters = [...root.querySelectorAll('[data-filter]')];
  const cards = [...root.querySelectorAll('[data-audience]')];
  const status = root.querySelector('[role="status"]');
  function filter(value) {
    filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === value)));
    cards.forEach(card => { card.hidden = value !== 'all' && card.dataset.audience !== value; });
    if (status) status.textContent = `${cards.filter(card => !card.hidden).length} ${root.dataset.statusLabel}`;
  }
  root.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => filter(button.dataset.filter)));
  root.querySelectorAll('[data-filter-link]').forEach(link => link.addEventListener('click', () => filter(link.dataset.filterLink)));
  root.querySelectorAll('[data-open-details]').forEach(button => button.addEventListener('click', () => {
    const dialog = document.getElementById(button.dataset.openDetails);
    if (dialog && !dialog.open) dialog.showModal();
  }));
  root.querySelectorAll('dialog').forEach(dialog => {
    dialog.querySelector('[data-close-details]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } });
  });
}
document.querySelectorAll('[data-nayorah-home]').forEach(initialiseNayorah);
document.addEventListener('shopify:section:load', event => initialiseNayorah(event.target.querySelector('[data-nayorah-home]')));
